import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertOctagon, Loader2 } from 'lucide-react';
import { format, parseISO } from 'date-fns';

const OverdueTasksList = ({ tasks, isLoading }) => {
  return (
    <Card className="bg-slate-800/70 border-slate-700 shadow-lg">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-slate-200 flex items-center">
          <AlertOctagon className="h-5 w-5 mr-2 text-red-400" />
          Overdue Tasks
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex items-center justify-center h-40">
            <Loader2 className="h-8 w-8 text-slate-400 animate-spin" />
          </div>
        ) : (
          <div className="space-y-3 max-h-80 overflow-y-auto">
            {tasks.length === 0 ? (
              <p className="text-slate-400 text-center py-4">No overdue tasks. Great job!</p>
            ) : (
              tasks.map((task, index) => (
                <motion.div
                  key={task.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                  className="p-3 bg-slate-700/50 rounded-md border border-slate-600"
                >
                  <div className="flex justify-between items-center">
                    <span className="text-sm font-medium text-slate-200">{task.name}</span>
                    <span className="text-xs text-red-400">
                      Due: {task.due_date ? format(parseISO(task.due_date), 'MMM dd, yyyy') : 'N/A'}
                    </span>
                  </div>
                  {task.projects && (
                    <p className="text-xs text-slate-400">Project: {task.projects.name}</p>
                  )}
                </motion.div>
              ))
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default OverdueTasksList;